export enum MedicalJournalFormat {
    Pdf = 'Pdf',
    Docx = 'Docx',
    Xlsx = 'Xlsx'
}
